import { push } from 'react-router-redux'

export default function locationMiddleware({ dispatch }) {
  return next => action => {
    const result = next(action)

    if (action.location) {
      const location =
        typeof action.location === 'function'
          ? action.location(result)
          : action.location

      if (location !== false) {
        dispatch(push(location))
      }
    }

    return result
  }
}



// WEBPACK FOOTER //
// ../src/middleware/location.js